"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericIndexScene = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
var outline_1 = require("@heroicons/react/outline");
var lodash_1 = __importDefault(require("lodash"));
var react_i18next_1 = require("react-i18next");
var use_index_1 = require("../../customs/hooks/use-index/use-index");
var GenericTable_1 = require("../../customs/react/generic-table/GenericTable");
var Card_1 = require("../Card");
var CardTitle_1 = require("../CardTitle");
var Pagination_1 = require("./Pagination");
var defaultPerPage = 15;
var fallbackOrderBy = { createdAt: 'asc' };
var GenericIndexScene = function (props) {
    var _a;
    var t = (0, react_i18next_1.useTranslation)(props.tNs).t;
    var _b = (0, use_index_1.useIndex)({
        perPage: (_a = props.perPage) !== null && _a !== void 0 ? _a : defaultPerPage,
        defaultOrderBy: props.defaultOrderBy || fallbackOrderBy,
        fetch: props.query[0],
        where: props.where,
        totalCount: lodash_1.default.get(props.query[1], "data.".concat(props.countPath), 0),
    }), pagination = _b.pagination, setOrderBy = _b.setOrderBy;
    var content = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.unwrapped ? undefined : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.Tool }), (0, jsx_runtime_1.jsx)(CardTitle_1.CardTitle, { children: t('title') })] })), (0, jsx_runtime_1.jsx)("div", { className: "overflow-x-auto", children: (0, jsx_runtime_1.jsx)(GenericTable_1.GenericTable, { columns: props.columns, onSortClick: setOrderBy, data: lodash_1.default.get(props.query[1].data, props.dataPath), sortIconClassNames: {
                        asc: function (_a) {
                            var onClick = _a.onClick;
                            return ((0, jsx_runtime_1.jsx)(outline_1.SortAscendingIcon, { height: 16, className: "inline-block ml-1 cursor-pointer", onClick: onClick }));
                        },
                        desc: function (_a) {
                            var onClick = _a.onClick;
                            return ((0, jsx_runtime_1.jsx)(outline_1.SortDescendingIcon, { height: 16, className: "inline-block ml-1 cursor-pointer", onClick: onClick }));
                        },
                    }, thActiveClassNames: "text-gray-900", tableClassNames: "bg-white min-w-full divide-y divide-gray-200 overflow-hidden border-b border-gray-200 rounded-lg", tHeadClassNames: "bg-gray-50", thClassNames: "px-6 py-3 text-left text-xs font-medium text-gray-color uppercase tracking-wider", tdClassNames: "px-6 py-4 text-sm font-medium", trClassNames: "even:bg-gray-50" }) }), (0, jsx_runtime_1.jsx)("div", { className: "pt-3", children: (0, jsx_runtime_1.jsx)(Pagination_1.Pagination, { pagination: pagination }) })] }));
    if (props.unwrapped) {
        return content;
    }
    return (0, jsx_runtime_1.jsx)(Card_1.Card, { children: content });
};
exports.GenericIndexScene = GenericIndexScene;
